import React from 'react';
import { INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { toolbarInsertBlockMessages } from '@atlaskit/editor-common/messages';
import { logException } from '@atlaskit/editor-common/monitoring';
import { IconLoom } from '@atlaskit/editor-common/quick-insert';
import { recordVideo, recordVideoFailed } from './commands';
import { createPlugin, loomPluginKey } from './pm-plugin';
import LoomToolbarButton from './ui/ToolbarButton';
export var loomPlugin = function loomPlugin(_ref) {
  var _api$analytics;
  var api = _ref.api;
  var editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
  return {
    name: 'loom',
    pmPlugins: function pmPlugins() {
      return [{
        name: 'loom',
        plugin: function plugin() {
          return createPlugin(api);
        }
      }];
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return;
      }
      return loomPluginKey.getState(editorState);
    },
    pluginsOptions: {
      // Enable inserting Loom recordings through the slash command
      quickInsert: function quickInsert(_ref2) {
        var formatMessage = _ref2.formatMessage;
        return [{
          id: 'loom',
          title: formatMessage(toolbarInsertBlockMessages.recordVideo),
          description: formatMessage(toolbarInsertBlockMessages.recordVideoDescription),
          keywords: ['loom', 'record', 'video'],
          priority: 800,
          icon: function icon() {
            return /*#__PURE__*/React.createElement(IconLoom, null);
          },
          action: function action(insert, editorState) {
            var _recordVideo;
            var tr = insert(undefined);
            var loomState = loomPluginKey.getState(editorState);
            if (!(loomState !== null && loomState !== void 0 && loomState.isEnabled)) {
              var _recordVideoFailed;
              var errorMessage = loomState === null || loomState === void 0 ? void 0 : loomState.error;
              logException(new Error(errorMessage), {
                location: 'editor-plugin-loom/quick-insert-record-video'
              });
              return (_recordVideoFailed = recordVideoFailed({
                inputMethod: INPUT_METHOD.QUICK_INSERT,
                error: errorMessage,
                editorAnalyticsAPI: editorAnalyticsAPI
              })({
                tr: tr
              })) !== null && _recordVideoFailed !== void 0 ? _recordVideoFailed : false;
            }
            return (_recordVideo = recordVideo({
              inputMethod: INPUT_METHOD.QUICK_INSERT,
              editorAnalyticsAPI: editorAnalyticsAPI
            })({
              tr: tr
            })) !== null && _recordVideo !== void 0 ? _recordVideo : false;
          }
        }];
      }
    },
    // Enable inserting Loom recordings through main toolbar
    primaryToolbarComponent: function primaryToolbarComponent(_ref3) {
      var disabled = _ref3.disabled;
      return /*#__PURE__*/React.createElement(LoomToolbarButton, {
        disabled: disabled,
        api: api
      });
    }
  };
};